import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import Header from './components/Header';
import Home from './components/Home';
import Form from './components/Form';
import Footer from './components/Footer';
import Loader from './components/Loader';

import './App.css';

function App() {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (location.state && location.state.scrollToId) {
      const targetSection = document.getElementById(location.state.scrollToId);
      if (targetSection) {
        targetSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location.state]);

  if (loading) {
    return <Loader />;
  }

  return (
      <div className="site-wrap">
        <Header />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/form" element={<Form />} />
        </Routes>

        <Footer />
      </div>
  );
}

export default App;
